import { render, staticRenderFns } from "./device-temp.vue?vue&type=template&id=3afd5ab4&scoped=true"
import script from "./device-temp.vue?vue&type=script&lang=js"
export * from "./device-temp.vue?vue&type=script&lang=js"
import style0 from "./device-temp.vue?vue&type=style&index=0&id=3afd5ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd5ab4",
  null
  
)

export default component.exports